import React, {useState} from 'react';
import { updateOperatorCurrentStatus } from "../../../../services/company/api";
import { t } from "../../../../components/Translate";
import DropdownSelect from "../../../../components-new/DropdownSelect";
import ColorIndicator from "../../../../components-new/ColorIndicator";

const StatusSelect = ({ user }) => {

    const statusOptions = [
        { value: 'AVAILABLE', label: t({ text: 'available', user }) },
        { value: 'PAUSE', label: t({ text: 'pause', user }) },
        { value: 'NOT_HERE', label: t({ text: 'not_here', user }) },
        { value: 'OFFLINE', label: t({ text: 'offline', user }) },
    ];

    const handleStatusChange = (newStatus) => {
        updateOperatorCurrentStatus(user.id, newStatus);
        setStatus(newStatus)
    };

    const [status, setStatus] = useState(user.currentStatus);

    return (
        <DropdownSelect
            options={statusOptions}
            selectedValue={status}
            onChange={handleStatusChange}
            renderIndicator={(value) => (
                <div style={{marginLeft: '10px'}}>
                    <ColorIndicator currentStatus={value}/>
                </div>
            )}
            renderLabel={(value) => t({ text: value ? value.toLowerCase() : "", user })}
        />
    );
};

export default StatusSelect;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/StatusSelect.jsx